import { ContactFilters__Input } from '~/graphql/types';
import { DEFAULT_EMPTY_FILTERS } from '~/hooks/useContactFiltersV2/constants';

const serializeFiltersV2 = (
  filters: ContactFilters__Input = DEFAULT_EMPTY_FILTERS,
): string => btoa(JSON.stringify(filters));

export default serializeFiltersV2;
